import React from 'react';
import PropTypes from 'prop-types';

import {
  DueMonthlyWrapper,
  DueNowText,
  Amount,
  Title,
  ButtonsWrapper
} from './css';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';

const Mobile = ({
  isFormTouched,
  isFormValidated,
  isChannelTISales,
  isChannelSMBDigitalFr,
  isFirstStep,
  isLastStep,
  dueMonthly,
  dueNow,
  onSaveAndExit,
  onDownloadClick,
  isOrderLastStep,
  onProceedClick,
  onBackClick,
  hidePricing,
  hideBackButton,
  isEligible,
  onCreateNewOrder,
  isCreateOrderVisible,
  disableContinue
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { DUE_MONTHLY, DUE_NOW, BEFORE_TAXES },
    formButtons: {
      saveContinueLaterButtonLabel,
      continueButtonLabel,
      downloadTheQuoteLabel,
      backLabel,
      newOrderButtonLabel,
      submitButtonLabel
    }
  } = localizedStrings;
  return (
    <div id="footer-low">
      {!hidePricing && (
        <>
          <DueMonthlyWrapper>
            <DueNowText>
              <span className="frg-body-font-14px color-white">
                {DUE_MONTHLY}
              </span>
              <Title>{BEFORE_TAXES}</Title>
              <span className="frg-body-font-14px color-white">{DUE_NOW}</span>
              <Title>{BEFORE_TAXES}</Title>
            </DueNowText>

            <Amount>
              <span className="frg-body-font-14px color-white">&nbsp;</span>
              <span className="frg-body-font-27px color-white">
                <div id="footer-monthly-total-low">{dueMonthly}</div>
              </span>
              <span className="frg-body-font-14px color-white">&nbsp;</span>
              <span className="frg-body-font-27px color-white">
                <div id="footer-now-total-low">{dueNow}</div>
              </span>
            </Amount>
          </DueMonthlyWrapper>
        </>
      )}

      {(!isOrderLastStep && (
        <ButtonsWrapper>
          {isFormValidated &&
            isLastStep &&
            !isChannelTISales &&
            isChannelSMBDigitalFr && (
              <button
                type="button"
                onClick={e => onDownloadClick(e)}
                className="frg-button color-green"
              >
                {downloadTheQuoteLabel}
              </button>
            )}
          {isFormValidated && isLastStep && isCreateOrderVisible && (
            <button
              type="button"
              onClick={e => onCreateNewOrder(e)}
              className="frg-button color-purple"
            >
              {newOrderButtonLabel}
            </button>
          )}
          {!isFormValidated && !isFirstStep && !hideBackButton && (
            <button
              type="button"
              onClick={e => onBackClick(e)}
              className="frg-button color-green"
            >
              <span>{backLabel}</span>
            </button>
          )}
          {!isFormValidated && !disableContinue && !isLastStep && (
            <button
              type="button"
              onClick={e => onSaveAndExit(e)}
              className="frg-button color-green"
              disabled={!isFormTouched}
            >
              <span>{saveContinueLaterButtonLabel}</span>
            </button>
          )}
          {!isFormValidated && (
            <button
              type="button"
              disabled={!isEligible}
              onClick={e => onProceedClick(e)}
              className="frg-button color-purple"
            >
              <span>{continueButtonLabel}</span>
            </button>
          )}
        </ButtonsWrapper>
      )) || (
        <ButtonsWrapper>
          <button
            type="button"
            disabled={!isEligible}
            onClick={e => onProceedClick(e)}
            className="frg-button color-purple"
          >
            <span>{submitButtonLabel}</span>
          </button>
        </ButtonsWrapper>
      )}
    </div>
  );
};

Mobile.propTypes = {
  dueMonthly: PropTypes.string.isRequired,
  dueNow: PropTypes.string.isRequired,
  onDownloadClick: PropTypes.func.isRequired,
  onProceedClick: PropTypes.func.isRequired,
  hidePricing: PropTypes.bool.isRequired,
  isFormTouched: PropTypes.bool.isRequired,
  isFormValidated: PropTypes.bool.isRequired,
  isChannelTISales: PropTypes.bool.isRequired,
  isChannelSMBDigitalFr: PropTypes.bool.isRequired,
  isFirstStep: PropTypes.bool,
  isLastStep: PropTypes.bool,
  isOrderLastStep: PropTypes.bool,
  onSaveAndExit: PropTypes.func.isRequired,
  onBackClick: PropTypes.func.isRequired,
  hideBackButton: PropTypes.bool.isRequired,
  isEligible: PropTypes.bool.isRequired,
  onCreateNewOrder: PropTypes.func.isRequired,
  isCreateOrderVisible: PropTypes.bool.isRequired,
  disableContinue: PropTypes.bool.isRequired
};

Mobile.defaultProps = {
  isFirstStep: false,
  isLastStep: false,
  isOrderLastStep: false
};

export default Mobile;
